<template>
  <!--新闻动态开始-->
  <div class="backdrop main-News" id="main-News">
    <p class="operation"><router-link to="/">{{$t('Home')}}</router-link> >> {{$t('News')}}</p>
    <p class="caption headline">NEWS</p>
    <p class="caption">新闻动态</p>
    <ul class="News-ul">
      <li v-for="obj in $t('newsTrends')">
        <div class="News-Data">
          <p>{{obj.id}}</p>
          <span>{{obj.date}}</span>
        </div>
        <div class="News-message">
          <h4>{{obj.title}}</h4>
          <span>{{obj.content}}</span>
        </div>
      </li>
    </ul>
    <div id="paging">
      <van-pagination v-model="currentPage" :total-items="24" :items-per-page="5"/>
    </div>
  </div>
  <!--新闻动态结束-->
</template>

<script>
  export default {
    name: "news",
    data() {
      return {
        currentPage: 1
      }
    }
  }
</script>

<style scoped>
  #paging{
    margin: auto;
    width: 50%;
    border: 1px solid #f8f8f8;
  }
  #main-News{
    padding: 50px 0;
  }
  /*新闻动态开始*/
  .main-News{
    background-image: url(../assets/img/pic/pic_NEWS.jpg);
    background-repeat:no-repeat;
  }
  .News-Data{
    width: 100px;
    height: 80px;
    background-color: #cc0000;
    color: #FFFFFF;
    text-align: center;
    padding:15px 5px;
  }
  .News-Data p{
    font-size: 30px;
  }
  .News-Data span{
    font-size: 16px;
  }
  .News-ul{
    margin: .3rem .7rem ;
  }
  .News-ul li{
    width: 100%;
    padding: 20px 0;
    border-bottom: 1px dotted #dbd4cd;
    overflow: hidden;
  }
  .News-ul li div{
    float: left;
  }
  .News-message{
    width: 85%;
    margin-left: 0.5rem;
  }

  .News-message span{
    font-size: 16px;
    line-height: 25px;
  }
  /*新闻动态结束*/

  @media screen and (max-width: 1024px) {
    /* 新闻动态 */
    .News-message{
      width: 80%;
      /* margin-left: 0.1rem; */
      font-size: 14px;
    }
    .News-message h4{

    }
    .News-message span{
      font-size: 12px;
    }
  }
  @media screen and (max-width:768px){
    /* 新闻动态 */
    .News-message{
      width: 60%;
      /* margin-left: 0.1rem; */
      font-size: 14px;
    }
    .News-message span{
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient:
        vertical;overflow: hidden;
    }

    #paging{
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/news.vue